import React from 'react';
import { Quote } from 'lucide-react';
import { FadeIn, StaggerContainer, StaggerItem } from './FadeIn';
export function Testimonials() {
  const testimonials = [{
    name: 'Alaric Svenholm',
    role: 'CEO',
    company: 'NovaMind Academy',
    quote: 'Cyberspire transformed our organic traffic. We went from page five to the top three results for our core courses in under six months.',
    color: 'bg-sage-50'
  }, {
    name: 'Ondine Castellari',
    role: 'Marketing Director',
    company: 'Praxis Learning Hub',
    quote: 'Their content strategy brought us 340% more qualified leads. They truly understand the e-learning space and how students search.',
    color: 'bg-lavender-50'
  }, {
    name: 'Percival Thane',
    role: 'Founder',
    company: 'Meridian Skill Forge',
    quote: "The ROI speaks for itself. Our cost per enrollment dropped by 60% after switching to Cyberspire's organic acquisition model.",
    color: 'bg-blue-50'
  }];
  return <section className="py-24 md:py-32 bg-cream-100 border-y border-cream-200" data-id="element-170">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-171">
        <FadeIn className="text-center mb-16" data-id="element-172">
          <h2 className="text-3xl md:text-4xl font-serif text-slate-900" data-id="element-173">
            Trusted by Leading Platforms
          </h2>
        </FadeIn>

        <StaggerContainer className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-174">
          {testimonials.map((testimonial, idx) => <StaggerItem key={idx} data-id="element-175">
              <div className={`h-full p-8 md:p-10 rounded-3xl ${testimonial.color} border border-white/60 shadow-sm relative`} data-id="element-176">
                <Quote className="absolute top-8 right-8 text-slate-900/10" size={48} data-id="element-177" />
                <div className="relative z-10" data-id="element-178">
                  <p className="text-lg text-slate-700 leading-relaxed mb-8 italic font-serif" data-id="element-179">
                    "{testimonial.quote}"
                  </p>
                  <div data-id="element-180">
                    <h4 className="font-medium text-slate-900" data-id="element-181">
                      {testimonial.name}
                    </h4>
                    <p className="text-sm text-slate-500" data-id="element-182">
                      {testimonial.role}, {testimonial.company}
                    </p>
                  </div>
                </div>
              </div>
            </StaggerItem>)}
        </StaggerContainer>
      </div>
    </section>;
}